import PrivacyPolicyNotification from './PrivacyPolicyNotification';

export default PrivacyPolicyNotification;
